export const GET_TIGERCAT_BURNS_GET_NOTES_SUCCESS = 'GET_TIGERCAT_BURNS_GET_NOTES_SUCCESS';
export const GET_TIGERCAT_BURNS_GET_NOTES_FAIL = 'GET_TIGERCAT_BURNS_GET_NOTES_FAIL';